// components/countryTransferPopup.js
import React, { useMemo, useState } from "react";
import "../utils/Style/component/modals.scss";
import { Modal } from "react-bootstrap";

function CountryTransferPopup({ isOpen, onClose, countries = [], onPick }) {
  const [q, setQ] = useState("");

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return countries;
    return countries.filter(
      (c) =>
        c?.name?.toLowerCase().includes(s) || c?.code?.toLowerCase().includes(s)
    );
  }, [q, countries]);

  return (
    <Modal
      centered
      show={isOpen}
      onHide={onClose}
      dialogClassName="country-transfer-modal"
    >
      <Modal.Body>
        <div className="mobile-confirmation-modal">
          <div className="header">
            <div className="modal-header-image">
              Select your Country of Transfers / Origin of Funds:
            </div>
          </div>
          <div className="search-container">
            <input
              type="text"
              placeholder="Search Country"
              className="search"
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
          </div>
        </div>

        <div className="modal-country-list">
          {filtered.map((c) => (
            <button
              key={c.id ?? c.code}
              className="country"
              onClick={() => onPick(c)}
            >
              <div className="flag">
                <img src={c.flagURL} className="flag-img" />
              </div>
              <div className="conntry-name">
                {c.name} {c.code ? `(${c.code})` : ""}
              </div>
            </button>
          ))}
        </div>

        <div className="cash-buttons mt-3">
          <button className="btn cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="btn continue-btn" onClick={onClose}>
            Continue
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CountryTransferPopup;
